import {
  Box,
  Button,
  Typography,
  Stack,
  Checkbox,
  FormControlLabel,
  TextField,
} from "@mui/material";
import { FC, useEffect, useState } from "react";
import CustomShimmer from "../../../components/CustomShimmer/CustomShimmer";
import "./RateUsPopUp.scss";
import { setError } from "../../../redux-store/reducers/CsErrorSlice";
import CustomPopup from "../../../components/CustomPopup/CustomPopup";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ArrowRightAlt from "@mui/icons-material/ArrowRightAlt";
import RateUsSuccessIcon from "../../../assets/icons/RateUsSucces.svg";
import {
  useLazyRateUsApiQuery,
  useLazyFetchRateUsContentQuery,
} from "../../../features/Feature_GeneralAppElements/GeneralAppElements_Api";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../redux-store/CustomReduxHooks";
import {
  executeIfNotPseudoUser,
  getMobileOperatingSystem,
  windowOpen,
} from "../../../utils/helper";
import useDeviceDetection from "../../../hooks/useDeviceDetection";
import CustomThreeDotsLoader from "../../../components/CustomThreeDotsLoader/CustomThreeDotsLoader";
import Slider from "@mui/material/Slider";
import {
  rateUsCmsContentData,
  FeedbackOptions,
  DEVICE_TYPE,
  SCREEN_TYPE,
  GTAScreenType,
  ABC_SERVICE_APPSTORE_URL,
  ABC_SERVICE_PLAYSTORE_URL,
  ALPHA_NUMERIC_WITH_SPACE_REGEX,
} from "../../../utils/constants";
import { Colors } from "../../../styles/constant";
import { T_CmsRateContentVariables } from "../../Features_Cms/CmsGlobal.Types";
import { triggerCleverTapEvent } from "../../../utils/CleverTap";
import { CleverTapEventType } from "../../../utils/CleverTapConstant";
import { CT_ScreenEvntDtls } from "../../Feature_CleverTap/ScreenEvents/CleverTapEventDetails";
import TriggerGTAEvent from "../../../utils/GTA";
import { useAppTranslation } from "../../../hooks/useAppTranslation";

interface Props {
  open: boolean;
  handleOpen: Function;
}

const RateUsPopUp: FC<Props> = ({ open, handleOpen }) => {
  const deviceType = useDeviceDetection();
  const [manualStep, setManualStep] = useState<number>(0);
  const [selectedValue, setSelectedValue] = useState(5);
  const [feedbackTextValue, setFeedbackTextValue] = useState<string>("");
  const [agreed, setAgreed] = useState(false);
  const [isBtnLoading, setIsBtnLoading] = useState<boolean>(false);
  const [isDisabled, setIsDisabled] = useState<boolean>(true);
  const [rateUsContent, setRateUsContent] =
    useState<T_CmsRateContentVariables>();
  const [localLoading, setLocalLoading] = useState(false);
  const dispatch = useAppDispatch();
  const [rateUsApi] = useLazyRateUsApiQuery();
  const userDetails = useAppSelector((state) => state.CsAppSlice.userDetails);
  const isPseudoLoggedIn = useAppSelector(
    (st) => st.PseudoLoginSlice.isPseudoLoggedIn,
  );
  const { t } = useAppTranslation("common");
  const [fetchRateUsContent] = useLazyFetchRateUsContentQuery();

  useEffect(() => {
    const getContent = async () => {
      setLocalLoading(true);
      await fetchRateUsContent().then((res) => {
        if (res.isSuccess) {
          if (res.data) {
            setRateUsContent(res.data.payload.data);
            setLocalLoading(false);
          }
        } else {
          setRateUsContent(rateUsCmsContentData);
          setLocalLoading(false);
        }
      });
    };
    getContent();
    setManualStep(0);
    setSelectedValue(5);
    setAgreed(false);
    setFeedbackTextValue("");
    triggerCleverTapEvent(CleverTapEventType.SCREEN_EVENT, {
      ScreenName: CT_ScreenEvntDtls.R_GAE.gaRateUsRateScale.screenName,
      ScreenType: SCREEN_TYPE.DashboardScreenType,
    });
  }, []);

  const handleClosePopup = () => {
    if (manualStep === 1) {
      setManualStep(0);
    } else {
      handleOpen(false);
    }
  };

  const handleClevertapGTMEvent = (
    type: string,
    drawerTitle?: string,
    formFieldValue?: string,
  ) => {
    if (type === "formfield") {
      triggerCleverTapEvent("serv_rate_us_submit_comment", {
        ScreenType: SCREEN_TYPE.generalAppType,
        ScreenName: "Servicing Rate Us What Went Wrong Detail Enter Screen",
        isPrevPageNameRequired: true,
        FormFieldValue: formFieldValue,
        ctaText: "Submit",
      });
      TriggerGTAEvent("serv_rate_us_submit_comment", {
        screen_type: GTAScreenType.DashboardScreenType,
        screen_name: "servicing_rate_us_what_went_wrong_detail_enter_screen",
        CTA_text: "Submit",
        drawer_tite: drawerTitle,
        field_placeholder_value: formFieldValue,
      });
    } else if (type === "checked" || type === "unchecked") {
      triggerCleverTapEvent("serv_rate_us_checkbox_interaction", {
        ScreenType: SCREEN_TYPE.generalAppType,
        ScreenName: "Servicing Rate Us Rating Scale Screen",
        isPrevPageNameRequired: true,
        ctaText: type,
        DrawerTitle: drawerTitle,
      });
      TriggerGTAEvent("serv_rate_us_checkbox_interaction", {
        screen_type: GTAScreenType.DashboardScreenType,
        screen_name: "servicing_rate_us_rating_scale_screen",
        CTA_text: type,
        drawer_tite: drawerTitle,
      });
    } else if (type === "Submit") {
      triggerCleverTapEvent("serv_rate_us_rating_submit", {
        ScreenType: SCREEN_TYPE.generalAppType,
        ScreenName: "Servicing Rate Us Rating Scale Screen",
        isPrevPageNameRequired: true,
        ctaText: type,
        DrawerTitle: drawerTitle,
      });
      TriggerGTAEvent("serv_rate_us_rating_submit", {
        screen_type: GTAScreenType.DashboardScreenType,
        screen_name: "servicing_rate_us_rating_scale_screen",
        CTA_text: type,
        drawer_tite: drawerTitle,
      });
    } else if (type === "Continue") {
      triggerCleverTapEvent("serv_rate_us_final_screen_cta_click", {
        ScreenType: SCREEN_TYPE.generalAppType,
        ScreenName: "Servicing Rate Us Thank You Screen",
        isPrevPageNameRequired: true,
        ctaText: type,
        DrawerTitle: drawerTitle,
      });
      TriggerGTAEvent("serv_rate_us_final_screen_cta_click", {
        screen_type: GTAScreenType.DashboardScreenType,
        screen_name: "servicing_rate_us_thank_you_screen",
        CTA_text: type,
        drawer_tite: drawerTitle,
      });
    }
  };

  const handleAgreeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAgreed(event.target.checked);
    if (event.target.checked === true) {
      handleClevertapGTMEvent("checked", "FINDING A FRIEND IN OUR APP");
    } else if (event.target.checked === false) {
      handleClevertapGTMEvent("unchecked", "FINDING A FRIEND IN OUR APP");
    }
  };

  const handleFeedbackSubmitClick = () => {
    executeIfNotPseudoUser(() => {
      handleClevertapGTMEvent(
        "formfield",
        "OH-OH! TELL US WHAT WENT WRONG",
        feedbackTextValue ? feedbackTextValue : "",
      );
      const requestData = {
        rating: selectedValue,
        feedback: feedbackTextValue ? feedbackTextValue : "",
        consent: agreed,
        mobile: userDetails?.mobileNumber,
      };
      setIsBtnLoading(true);
      rateUsApi(requestData).then(async (res) => {
        setIsBtnLoading(false);
        if (res.isSuccess) {
          if (deviceType === DEVICE_TYPE.WEB) {
            handleClevertapGTMEvent("Submit", "FINDING A FRIEND IN OUR APP");
            setManualStep(1);
          } else {
            if (selectedValue <= 3) {
              setManualStep(1);
            } else {
              setManualStep(2);
            }
          }
        } else if (res.isError || res.data?.code !== 1) {
          dispatch(
            setError({
              error: new Error("Error"),
              message: "Rate Us API failed",
            }),
          );
        }
      });
    }, isPseudoLoggedIn);
  };

  const handleContinueClick = () => {
    handleClevertapGTMEvent(
      "Continue",
      rateUsContent?.attributes.successMessage,
    );
    handleOpen(false);
  };

  const handleEmojiClick = (
    index: number,
    text?: string,
    drawerTitle?: string,
  ) => {
    triggerCleverTapEvent("serv_rate_us_rating_selection", {
      ScreenType: SCREEN_TYPE.generalAppType,
      ScreenName: "Servicing Rate Us Rating Scale Screen",
      isPrevPageNameRequired: true,
      ctaText: text,
      DrawerTitle: drawerTitle,
    });
    TriggerGTAEvent("serv_rate_us_rating_selection", {
      screen_type: GTAScreenType.DashboardScreenType,
      screen_name: "servicing_rate_us_rating_scale_screen",
      CTA_text: text,
      drawer_tite: drawerTitle,
    });
    setIsDisabled(false);
    setSelectedValue(index + 1);
  };

  // Handle slider change
  const handleSliderChange = (event: any, newValue: any) => {
    setIsDisabled(false);
    setSelectedValue(newValue);
  };

  const handleYesRateClick = () => {
    if (getMobileOperatingSystem() === "iOS") {
      windowOpen(ABC_SERVICE_APPSTORE_URL);
    } else {
      windowOpen(ABC_SERVICE_PLAYSTORE_URL);
    }
  };

  const handleNoRateClick = () => {
    setManualStep(1);
  };

  useEffect(() => {
    if (manualStep === 1) {
      triggerCleverTapEvent(CleverTapEventType.SCREEN_EVENT, {
        ScreenName: CT_ScreenEvntDtls.R_GAE.gaRateUsThankyou.screenName,
        ScreenType: SCREEN_TYPE.DashboardScreenType,
      });
    }
  }, [manualStep]);

  const renderSteps = () => {
    switch (manualStep) {
      case 0:
        return (
          <Box display="flex" flexDirection="column">
            <Typography textAlign="center" variant="h6">
              {localLoading ? (
                <CustomShimmer width="80%" />
              ) : (
                t("rateUs.title") || rateUsContent?.attributes.title
              )}
            </Typography>
            <Typography
              textAlign="center"
              variant="subtitle2"
              marginTop={"0.5rem"}
              marginBottom={"2.5rem"}
            >
              {localLoading ? (
                <CustomShimmer width="80%" />
              ) : (
                t("rateUs.subTitle") || rateUsContent?.attributes.subTitle
              )}
            </Typography>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              {FeedbackOptions.map((option, index) => (
                <Box key={option.label} display="flex" flexDirection="column">
                  <img
                    src={`${
                      index + 1 === selectedValue
                        ? option.postIcon
                        : option.preIcon
                    }`}
                    onClick={() => {
                      handleEmojiClick(
                        index,
                        option.key,
                        "FINDING A FRIEND IN OUR APP",
                      );
                    }}
                    alt="emoji"
                    className="emoji-icon"
                  />
                  <Box
                    fontSize={"0.688rem"}
                    fontWeight={"700"}
                    textAlign={"center"}
                    color={`${
                      index + 1 === selectedValue ? "#4C4C4C" : "#DADADA"
                    }`}
                    lineHeight={"1rem"}
                  >
                    {option.label}
                  </Box>
                </Box>
              ))}
            </Box>
            <Slider
              value={selectedValue}
              min={1}
              max={5}
              className={`${
                selectedValue >= 3
                  ? "slider-color-green"
                  : "slider-color-yellow"
              }`}
              step={1}
              marks
              onChange={handleSliderChange}
              sx={{ width: "94%", marginX: "auto" }}
            />
            <Box
              className="comment-box-section"
              sx={{ width: "94%", marginX: "auto" }}
            >
              <Typography
                textAlign="center"
                variant="subtitle2"
                marginTop={"0.5rem"}
                marginBottom={"1rem"}
              >
                {t("rateUs.leaveYourComments")}
              </Typography>
              <TextField
                value={feedbackTextValue}
                onChange={(e) => {
                  const input = e.target.value;
                  const alphaNumericOnly = input.replace(
                    ALPHA_NUMERIC_WITH_SPACE_REGEX,
                    "",
                  );
                  if (alphaNumericOnly.length <= 300) {
                    setFeedbackTextValue(alphaNumericOnly);
                  }
                }}
                multiline
                rows={4}
                fullWidth
                variant="outlined"
                inputProps={{ maxLength: 300 }}
              />
            </Box>
            <Box marginTop={"1rem"}>
              <FormControlLabel
                control={
                  <Checkbox checked={agreed} onChange={handleAgreeChange} />
                }
                label={
                  <Typography variant="subtitle2">
                    {localLoading ? (
                      <CustomShimmer width="15rem" />
                    ) : (
                      t("rateUs.checkBox") || rateUsContent?.attributes.checkBox
                    )}
                  </Typography>
                }
                className="terms-condition-check"
              />
            </Box>
            {isBtnLoading ? (
              <CustomThreeDotsLoader />
            ) : (
              <Button
                fullWidth
                variant="contained"
                // disabled={!feedbackTextValue}
                className="continue-btn"
                onClick={handleFeedbackSubmitClick}
              >
                {t("rateUs.submit")}
              </Button>
            )}
          </Box>
        );
      case 1:
        return (
          <Box>
            <Typography textAlign="center" variant="h6">
              {localLoading ? (
                <CustomShimmer width="80%" />
              ) : (
                t("rateUs.successTitle") ||
                rateUsContent?.attributes.successTitle
              )}
            </Typography>
            <Stack alignItems={"center"}>
              <img
                src={RateUsSuccessIcon}
                alt="rateussuccess"
                className="success-image"
              />
            </Stack>
            <Typography variant="subtitle2" className="thankyou-content">
              {localLoading ? (
                <CustomShimmer width="80%" />
              ) : (
                t("rateUs.successMessage") ||
                rateUsContent?.attributes.successMessage
              )}
            </Typography>
            <Button
              fullWidth
              variant="contained"
              className="continue-btn"
              onClick={handleContinueClick}
            >
              {t("rateUs.continue")}
            </Button>
          </Box>
        );
      case 2:
        return (
          <Box>
            <Typography textAlign="center" className="rateus-title">
              {t("rateUs.rateUs")}
            </Typography>
            <Typography
              variant="subtitle2"
              className="thankyou-content"
              margin={"2rem 0.125rem"}
            >
              {t("rateUs.rateUsIn")}{" "}
              {getMobileOperatingSystem() === "iOS" ? `AppStore` : `PlayStore`}?
            </Typography>
            <Button
              fullWidth
              variant="contained"
              className="continue-btn"
              onClick={handleYesRateClick}
            >
              {t("rateUs.yesContinue")}
            </Button>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              marginTop={"0.625rem"}
              marginBottom={"2rem"}
            >
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: "12px",
                  color: "#C7222A",
                  cursor: "pointer",
                }}
                onClick={handleNoRateClick}
              >
                {t("rateUs.noThanks")}
              </Typography>
              <ArrowRightAlt
                sx={{
                  fontWeight: 600,
                  color: "#C7222A",
                }}
              />
            </Box>
          </Box>
        );
    }
  };

  return (
    <CustomPopup
      open={open}
      handleOpen={handleClosePopup}
      className="rateUs-popup"
      btnLabel={t("rateUs.goBack")}
      btnStartIcon={
        <ChevronLeftIcon fontSize="small" sx={{ color: Colors.red }} />
      }
    >
      <Box>{renderSteps()}</Box>
    </CustomPopup>
  );
};

export default RateUsPopUp;
